module.exports = __webpack_public_path__ + "img/full5-min.b3293b74.png";